import { PasswordValidatorOpts } from '../../../validators/password.validator';

export const AUTH_PASSWORD_VALIDATOR_OPTS: PasswordValidatorOpts = {
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSymbol: true,
  minLength: 8,
  maxLength: 50
};
